// 배럴(goi_common)이 아니라 소스 경로로 직접 가져온다. scripts/check-care-facility-lead.cjs 가
// React 트리를 로드하지 않고 이 파일만 돌릴 수 있어야 한다.
import { CARE_VISIT_LABEL, CareVisitType } from "goi_common/src/utils/careFacilityVisit";

/**
 * 요양병원/호스피스를 본 뒤 시설 상세(장례식장/장지/화장장)에서 제출한 리드의 #홈 질문 슬랙 본문.
 *
 * buildParlorRevisitLeadMessage(재방문 = 장례식장 오인지 의심)와 문맥이 반대다. 이쪽은
 * "요양병원을 이미 탐색한, 임박 확률이 높은 고객" 이라는 전제를 상담원에게 먼저 알린다.
 *
 * v2: 헤더·전화번호·GA/Hackle/GCLID 는 BE(postLeadV2)가 붙인다. 여기선 사람용 본문만.
 * status 는 보내지 않으므로 슬랙 *메모* 는 붙지 않는다 (모달이 임박도를 묻지 않음).
 */
export function buildCareFacilityLeadMessage({
  visitType,
  facilityName,
  sidoLabel,
  region,
  mournerCount,
}: {
  visitType: CareVisitType;
  /** 모달을 띄운 시설 이름 */
  facilityName: string;
  /** 모달 제목에 쓴 시도 ("서울시") */
  sidoLabel: string;
  /** "서울시 강남구" 처럼 시도+시군구 */
  region: string;
  /** 1단계에서 선택한 예상 조문객수 */
  mournerCount: string;
}): string {
  const visitLabel = CARE_VISIT_LABEL[visitType];

  return [
    `질문 내용 : *${sidoLabel} 장례 준비 문의*`,
    "",
    `궁금한 점 : *${sidoLabel} 장례 준비를 도움받고 싶어요.*`,
    "-----",
    `${visitLabel} 탐색 후 장례 시설을 탐색하다가 리드를 제출한 고객님입니다.`,
    `${visitLabel}에 계신 비교적 임박 고객임을 인지한 상태로 상담 진행 부탁드립니다.`,
    "",
    `시설 : *${facilityName}*`,
    `지역 : *${region}*`,
    `예상 조문객수 : *${mournerCount}*`,
  ].join("\n");
}
